export const ADD_ALERT = 'ADD_ALERT';
export const CLEAR_ALERT = 'CLEAR_ALERT';
export const ADD_ATHLETE = 'ADD_ATHLETE';
export const REMOVE_ATHLETE = 'REMOVE_ATHLETE';
export const UPDATE_FRIENDS = 'UPDATE_FRIENDS';
export const UPDATE_FRIEND_FOLLOWING_STATUS = 'UPDATE_FRIEND_FOLLOWING_STATUS';

export default {
  ADD_ALERT,
  CLEAR_ALERT,
  ADD_ATHLETE,
  REMOVE_ATHLETE,
  UPDATE_FRIENDS,
  UPDATE_FRIEND_FOLLOWING_STATUS
};
